export class CustomerService {
  public static getApiPath = (requestType: string): string => {
    return `/customer/${requestType}/requests/list/`;
  };
}

export default CustomerService;
